import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SaysoRoutingModule } from "./sayso-routing.module";

@NgModule({
  imports: [CommonModule, SaysoRoutingModule]
})
export class SaysoModule {}
